import { createSlice } from '@reduxjs/toolkit';
import type { ProjectState } from './types';

const slice = createSlice({
  name: 'project',
  initialState: {
    counts: [],
    monthlyCounts: [],
  } as ProjectState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setProject: (state, action) => {
      state.project = action.payload;
      state.loading = false;
      state.error = undefined;
    },
    setCounts: (state, action) => {
      state.counts = action.payload;
    },
    setMonthlyCounts: (state, action) => {
      state.monthlyCounts = action.payload;
    },
    setProEst: (state, action) => {
      state.proEst = action.payload;
    },
    setExcel: (state, action) => {
      state.excel = action.payload;
    },
    setProjectNames: (state, action) => {
      state.projectNames = action.payload;
    },
  },
});

export const projectActions = slice.actions;
export const projectReducer = slice.reducer;
